import { Grid, Skeleton } from '@mui/material'
import React from 'react'

function TrainingEditSkeleton() {
    return (
        <Grid container spacing={3} p={3}>
            {[...Array(5)].map((e, i) => (
                <Grid key={e} item md={12}>
                    <Skeleton variant='rectangular' sx={{ minWidth: '100%', width: '220px', borderRadius: 1 }} height={50}></Skeleton>
                </Grid>
            ))
            }
        </Grid >
    )
}

export default TrainingEditSkeleton